import { Typography } from '@euler/app/components/typography';
import { BottomPanel } from '@euler/components/BottomPanel';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { CoachingAnchor } from '@euler/model/coaching-practice';
import { memo } from 'react';
import { View } from 'react-native';
import {
  PrimaryButton,
  SecondaryButton,
} from '../../../../../ai-suite/components/PrimaryButton';
import { aiColors } from '../../../../../ai-suite/theme';

/** After a moment replay: how it went, again or back to the report. */
export const ReplayVerdictSheet = memo(
  ({
    verdict,
    onAgain,
    onBack,
  }: {
    verdict: CoachingAnchor | null;
    onAgain: () => void;
    onBack: () => void;
  }) => {
    const { rpx } = useResponsiveContext();
    const strong = verdict === CoachingAnchor.Strong;
    return (
      <BottomPanel visible={verdict != null} onClose={onBack} fitContent>
        <View style={{ padding: rpx(20), gap: rpx(14) }}>
          <Typography.Text
            size={rpx(17)}
            bold
            color={strong ? aiColors.green : aiColors.foreground}
          >
            {strong ? '👏 这次到位了' : '还差一点'}
          </Typography.Text>
          <Typography.Text size={rpx(13)} color={aiColors.mutedForeground}>
            重练不会改变报告的星级。
          </Typography.Text>
          <PrimaryButton title="回到报告" onPress={onBack} />
          <SecondaryButton title="再来一次" onPress={onAgain} />
        </View>
      </BottomPanel>
    );
  },
);
